module.exports = __webpack_public_path__ + "img/file-------------------------------------------------------------2@1x.9a82568a.png";